<template>
  <div>
    <b-navbar toggleable="lg" type="light" variant="primary" fixed="top">
      <b-container>
        <b-navbar-brand href="/private/tour/search">
          <img src="@/assets/images/logo-interra-2.svg" alt="interra logo" class="logo-img">
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <navMenu></navMenu>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto d-flex align-items-end">
            <userData/>
            <secondaryMenu/>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>
import navMenu from './main_menu'
import secondaryMenu from './secondary_menu'
import userData from './user_data'
export default {
  name: 'Menu',
  components: { navMenu, secondaryMenu, userData }
}
</script>

<style lang="scss" scoped>

</style>
